<template>
  <div>
     <div class="b-kyc-data">
    <router-link 
      class="b-kyc-data-button"
       :class="{ 'b-kyc-data-button-highlight': kyc_verification_type == 'kyc' }"
      :to="{ name: 'admin', params: {kyc_verification_type: 'kyc'} }">
      Kyc 
    </router-link>
    <router-link 
      class="b-kyc-data-button"
       :class="{ 'b-kyc-data-button-highlight': kyc_verification_type == 'ckyc' }"
      :to="{ name: 'admin', params: {kyc_verification_type: 'ckyc'} }">
      CKYC
    </router-link>  
    <router-link 
      class="b-kyc-data-button"
       :class="{ 'b-kyc-data-button-highlight': kyc_verification_type == 'video' }"
      :to="{ name: 'admin', params: {kyc_verification_type: 'video'} }">
      Video
    </router-link>
    <router-link 
      class="b-kyc-data-button"
       :class="{ 'b-kyc-data-button-highlight': kyc_verification_type == 'signature' }"
      :to="{ name: 'admin', params: {kyc_verification_type: 'signature'} }">
      Signature
    </router-link>   
    </div>
    <router-view 
      v-title="'KYC auto Verification'"
      :key="$route.fullPath">
    </router-view>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'

export default {
  mounted() {
    this.$store.commit('reset_admin_partner'); 
    //if (this.$route.name == "dashboard"){
      // this.$router.push({ name: 'home'});
      //  this.$router.push({ name: 'kyc-details', params: {status: "Pending", partner: this.admin_partner}});
      // this.$router.push("/kyc-details/Pending");
    //}
    // this.$router.push({ name: this.$route.name, params: { status: this.$route.params.status } });

  },

  computed: {
    get_tab_view(){
      return this.$route.name.split("-")[0]
    },
    ...mapState({ 
      admin_partner: state => state.kycLogin.admin_partner,
      kyc_verification_type: state => state.kycLogin.kyc_verification_type}), 
  },

  watch: {
    kyc_verification_type(newValue, oldValue) {
      if(newValue != oldValue)
        this.$store.commit('reset_admin_partner'); 
    },
  }
  // ...mapGetters(['admin_partner']),
  
};
</script>



<style scoped>
.row-highlight {
  background-color: #24cdc6;
}
.amc-option {
  width: 285px;
  margin: 1px;
  height:34px;
  font-size:15px;
}

.b-kyc-data{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 75px 75px 20px 75px;
  justify-content: center;
}
.b-kyc-data-button {
  font-size: 2em !important;
  line-height: 2em !important;
  margin-top:10px;
  margin-right: 10px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  border-color: #03b9f5;  
  padding: 5px;
  text-decoration: none;
}
.b-kyc-data-button-highlight {
  background-color: #03b9f5;
  color: white;
}

input {
  margin: 15px auto;
  display: block;
  width: 50%;
  padding: 8px;
  border: 1px solid black;
}

.b-container-btn {
  text-align: center;
  cursor: pointer;
}
  
.b-margin{
  margin-right: 20px;
}
</style>
